export const QUERIES = {
  monetizationOnboarding: 'monetization-onboarding',
  monetizationCreatorProducts: 'monetization-products',
  monetizationUserSubscriptions: 'monetization-subscriptions',
  monetizationDonations: 'monetization-donations',
  monetizationTransactions: 'monetization-transactions',
};
